import PolicyPage from "../components/PolicyPage";

export default function ShippingReturns() {
  return (
    <PolicyPage
      testId="shipping-returns-page"
      eyebrow="Sumanya · Policies"
      title="Shipping & Returns"
      subtitle="Every order is carefully checked, securely packed and dispatched through our designated delivery partners."
      updated="February 2026"
      sections={[
        {
          heading: "Shipping",
          body: [
            "At Sumanya, we take special care in preparing and dispatching your jewellery. Every order is carefully checked, securely packed and dispatched through our designated delivery partners.",
            "Once your order has been dispatched, you will receive the available tracking information so that you can follow your shipment.",
          ],
        },
        {
          heading: "Delivery",
          body: "Delivery timelines may vary depending on the destination, product availability, payment confirmation, verification requirements and the delivery partner. For certain high-value jewellery orders, additional verification may be required before dispatch. The jewellery may be delivered only to the address provided during checkout, subject to our delivery and verification procedures.",
        },
        {
          heading: "At the time of delivery",
          body: "Please inspect the outer package carefully when receiving your order. If the package appears damaged, opened or tampered with, please:",
          bullets: [
            "Record the condition of the package.",
            "Take photographs / videos where possible.",
            "Contact Sumanya immediately.",
          ],
          note: "Customers are advised to retain all original packaging until the product has been fully inspected.",
        },
        {
          heading: "Returns & Exchange",
          body: "Jewellery is a high-value and often customised product. Therefore, our return and exchange policy is subject to specific conditions. If you do not like the jewellery purchased online, an eligible product may be exchanged within 7 days of delivery, provided:",
          bullets: [
            "The product is unused.",
            "There is no breakage, damage, scratch, alteration or other physical damage.",
            "The product is returned in its original condition.",
            "Original packaging and documents are available.",
            "The original invoice / order details are available.",
            "The product is not specifically excluded from exchange.",
          ],
          note: "All exchange requests are subject to inspection and approval by Sumanya.",
        },
        {
          heading: "Return initiation fee",
          body: "To cover secure reverse-logistics pickup, insurance during transit and quality inspection, a non-refundable return initiation fee of ₹250 per shipment will be deducted from the refund / exchange value once a return is approved. This fee is applied only when a return is initiated by the customer and does not apply to returns arising from damage in transit or a proven manufacturing defect.",
          note: "Return initiation fee: ₹250 per shipment (non-refundable). This amount may be revised from time to time — the applicable amount at the time of return will apply.",
        },
        {
          heading: "Products not eligible for exchange",
          bullets: [
            "Gemstones.",
            "Products specifically marked as non-returnable / non-exchangeable.",
            "Products that have been altered or customised at the customer’s request.",
            "Products showing signs of use, damage or modification.",
            "Products without required original certificates / documents.",
          ],
        },
        {
          heading: "Diamond jewellery",
          body: [
            "Diamond jewellery is subject to separate exchange terms.",
            "Eligible diamond jewellery may be exchanged after applicable deductions, including 10% of the diamond value and making charges. The original diamond certificate / certificate card must be returned with the jewellery where applicable.",
          ],
        },
        {
          heading: "Exchange after 7 days",
          body: "After 7 days, eligible 916 and 750 gold jewellery may be considered for exchange under our applicable exchange policy. Gold value will be calculated at the applicable prevailing MCX / gold rate and purity:",
          bullets: [
            "916 Gold: 91.60%",
            "750 Gold: 75.00%",
          ],
          note: "Making charges are not refundable.",
        },
        {
          heading: "Refunds",
          body: [
            "Where a refund is applicable, an additional 2% deduction may apply for cash refunds.",
            "Where the refund is processed through the original payment method, it may take approximately 14–15 business days, depending on the relevant bank / payment provider.",
            "For complete terms, please refer to our Terms & Conditions.",
          ],
        },
      ]}
    />
  );
}
